import { type DossierStatusId, StatusBadge } from "../status";

interface DossierRow {
  ref: string;
  researcher: string;
  project: string;
  faculty: string;
  submitted: string;
  status: DossierStatusId;
}

const ROWS: DossierRow[] = [
  {
    ref: "EA-2026-043",
    researcher: "Lien Maes",
    project: "Kwalitatief onderzoek in de jeugdzorg",
    faculty: "GGW",
    submitted: "24 jun",
    status: "secr-klaar",
  },
  {
    ref: "EA-2026-042",
    researcher: "Karim El Idrissi",
    project: "Survey over migratie en gezondheid",
    faculty: "FBD",
    submitted: "23 jun",
    status: "issues-gevonden",
  },
  {
    ref: "EA-2026-041",
    researcher: "Sofie Peeters",
    project: "Interviews over psychische kwetsbaarheid",
    faculty: "GGW",
    submitted: "22 jun",
    status: "herziening-nodig",
  },
  {
    ref: "EA-2026-040",
    researcher: "Tom Vermeulen",
    project: "Observatiestudie op de arbeidsmarkt",
    faculty: "TEW",
    submitted: "21 jun",
    status: "bureau-review",
  },
  {
    ref: "EA-2026-039",
    researcher: "An Declercq",
    project: "Focusgroep over onderwijs en diversiteit",
    faculty: "FBD",
    submitted: "19 jun",
    status: "advies-verzonden",
  },
  {
    ref: "EA-2026-038",
    researcher: "Jonas Willems",
    project: "Longitudinale studie in de ouderenzorg",
    faculty: "GGW",
    submitted: "18 jun",
    status: "bureau-review",
  },
  {
    ref: "EA-2026-037",
    researcher: "Nathalie Goris",
    project: "Experiment over cognitieve belasting",
    faculty: "LW",
    submitted: "17 jun",
    status: "issues-gevonden",
  },
  {
    ref: "EA-2026-036",
    researcher: "Pieter Claes",
    project: "Mixed methods over armoede en welzijn",
    faculty: "FBD",
    submitted: "16 jun",
    status: "secr-klaar",
  },
  {
    ref: "EA-2026-035",
    researcher: "Yasmine Khalil",
    project: "Survey over religie en integratie",
    faculty: "FBD",
    submitted: "14 jun",
    status: "issues-gevonden",
  },
  {
    ref: "EA-2026-034",
    researcher: "Bert Janssen",
    project: "Casestudy over digitale geletterdheid",
    faculty: "TEW",
    submitted: "12 jun",
    status: "bureau-review",
  },
];

export function DossiersPage() {
  return (
    <section>
      <div className="page-head">
        <div>
          <h1>Alle dossiers</h1>
          <p>Academisch jaar 2025–2026 · 43 actief, 112 afgerond</p>
        </div>
      </div>

      <div className="card ua-mb-space">
        <div className="card__body ua-card-filter">
          <select className="filter-select">
            <option>Alle statussen</option>
            <option>Draft intake</option>
            <option>Pre-screening</option>
            <option>Secr. klaar-check</option>
            <option>Bureau review</option>
            <option>Advies verzonden</option>
          </select>
          <select className="filter-select">
            <option>Alle faculteiten</option>
            <option>FBD</option>
            <option>GGW</option>
            <option>TEW</option>
            <option>REC</option>
            <option>LW</option>
            <option>WET</option>
          </select>
          <select className="filter-select">
            <option>Alle academiejaren</option>
            <option>Academiejaar 2025–2026</option>
            <option>Academiejaar 2024–2025</option>
            <option>Academiejaar 2023–2024</option>
          </select>
          <span className="ua-flex-1" />
          <span className="ua-muted-sm">43 resultaten</span>
        </div>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>Ref.</th>
              <th>Onderzoeker</th>
              <th>Project</th>
              <th>Faculteit</th>
              <th>Ingediend</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.ref}>
                <td className="ua-muted-xs">{row.ref}</td>
                <td>{row.researcher}</td>
                <td className="text-[13px]">{row.project}</td>
                <td>
                  <span className="badge badge--info">{row.faculty}</span>
                </td>
                <td>{row.submitted}</td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>
                  <a href="#" className="text-[13px]">
                    Bekijk
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="ua-pager">
          <span className="ua-muted-sm">1–10 van 43</span>
          <div className="ua-flex-actions">
            <button className="btn btn--ghost px-3 py-[5px] text-[13px]">← Vorige</button>
            <button className="btn btn--ghost px-3 py-[5px] text-[13px]">Volgende →</button>
          </div>
        </div>
      </div>
    </section>
  );
}
